import { handleAlert as showAlert, handleError } from "@optigrit/optigrit-ui";


export const handleAlert = (message, type) => {
  if (!message && !type) {
    handleError();
    return;
  };
  if (!type) {
    showAlert(message, 'info');
    return;
  }

  showAlert(message, type)
};
